import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import ReportCard from "../../../../../components/reports/report-card.jsx";

const CardsContent = ({ data }) => {
    const cards = JSON.parse(data?.apply?.cards?.[0]?.text ?? "{}");

    useEffect(() => {
        const values = [
            ["Total de alarmes", cards.alarms ?? 0],
            ["Assinados na 1ª fase", cards.first_sign ?? 0],
            ["Assinados na 2ª fase", cards.second_sign ?? 0],
            ["Total de ocorrências", cards.occ_qty ?? 0],
            ["Alarmes com mais de uma ocorrência", cards.alarms_multiple_occ ?? 0],
            ["Total de placas", cards.plates ?? 0],
        ];

        ReportUtils.createExportableTable(["Descrição", "Quantidade"], values, "Cards");
    }, [data]);

    return (
        <>
            <div className="flex flex-col">
                <div className="grid grid-cols-3">
                    <ReportCard title="Total de alarmes" value={cards.alarms ?? 0}/>
                    <ReportCard title="Assinados na 1ª fase" value={cards.first_sign ?? 0}/>
                    <ReportCard title="Assinados na 2ª fase" value={cards.second_sign ?? 0}/>
                </div>
                <div className="grid grid-cols-3">
                    <ReportCard title="Total de ocorrências" value={cards.occ_qty ?? 0}/>
                    <ReportCard title="Alarmes com mais de uma ocorrência" value={cards.alarms_multiple_occ ?? 0}/>
                    <ReportCard title="Total de placas" value={cards.plates ?? 0}/>
                </div>
            </div>

            <div className="chart-divisor"/>
        </>
    );
};

export default CardsContent;